<template>
  <div class="end-container">
    <div class="end-main">
      <div class="left">
        <div class="xi-img-container">
          <img src="../new-assets/06-1.png" class="xi-img" alt="" />
          <!--
            src="https://jcdn.xhby.net/project/xiaokang/assets/end/xidada.png"
           -->
          <div class="play-bar">
            <img
              src="https://jcdn.xhby.net/project/xiaokang/assets/end/06-play.png"
              alt=""
              class="play-icon"
              v-if="!playing"
              @click="play"
            />
            <img
              src="https://jcdn.xhby.net/project/xiaokang/assets/end/06-stop.png"
              alt=""
              class="play-icon"
              @click="stop"
              v-else
            />
            <div class="real-bar-container" @click="onBarTap">
              <div class="bg-bar" ref="bgBar">
                <div class="front-bar" :style="{ width: `${playingPercent}%` }">
                  <div class="ball"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <img src="../new-assets/06-2.png" alt="" class="xi-text" />
      </div>
    </div>

    <div class="control-bar">
      <div style="flex: 1"></div>
      <div class="look-more" @click="jumpOut">点击查看更多故事</div>
      <div class="banquan" @click="isShowDetail = true">版&nbsp;权</div>
      <div class="fanhui" @click="back">返&nbsp;回</div>
    </div>

    <div class="dialog-container" v-if="isShowDetail">
      <div class="dialog-inner">
        <img
          src="https://jcdn.xhby.net/project/xiaokang/assets/detail/close.png"
          alt=""
          class="close-img"
          @click="isShowDetail = false"
        />
        <div class="dialog-inner-2 nice-scroll">
          <img src="../new-assets/logos.png" alt="" class="banquan" />
          <div class="divider"></div>
          <div class="line">总指导：双传学　顾雷鸣</div>
          <div class="line">总策划：李扬</div>
          <div class="divider"></div>
          <div class="line">监制：任松筠　田梅</div>
          <div class="line">统筹：高伟　朱威</div>
          <!-- <div class="line">技术总监：夏霖　朱昕磊</div> -->
          <div class="line">文案：朱威　韦伟</div>
          <div class="line">视觉设计：杨晓珑</div>
          <div class="line">音频剪辑：刘畅方达</div>
          <div class="line">内容采集：交汇点新闻“听·见小康”工作室</div>
          <div class="line">栏目主播：董双</div>
          <div class="divider"></div>
          <div class="line">音视频统筹：吴盈青</div>
          <div class="line">图片统筹：虞越</div>
          <div class="line">片头剪辑：穆怀佳</div>
          <div class="divider"></div>
          <div class="line">页面开发：朱昕磊　杜鲁　崔阳　陈雨生</div>
          <div class="line">技术支持：江苏新华烽火数据技术有限公司</div>
        </div>
      </div>
    </div>
    <audio
      :src="'https://jcdn.xhby.net/project/xiaokang/assets/audio/xi/xiaokang.mp3'"
      ref="audio"
      @timeupdate="onPlaying"
    ></audio>
  </div>
</template>

<script >
export default {
  props: {
    back: Function,
  },
  data() {
    return {
      isShowDetail: false,

      playingPercent: 0,
      playing: false,
    };
  },
  methods: {
    jumpOut() {
      // location.href =
      //   "https://jnews.xhby.net/v3/waparticles/12/TNqWXckq4exGZM8s/1";
      window.open(
        "https://jnews.xhby.net/v3/waparticles/12/TNqWXckq4exGZM8s/1"
      );
    },

    onBarTap(e) {
      const clientX = e.clientX;
      const bgRect = this.$refs.bgBar.getBoundingClientRect();

      const durLength = clientX - bgRect.left;
      const durPercent = durLength / bgRect.width;

      const audioInstance = this.$refs.audio;
      if (!audioInstance) return;
      const dur = audioInstance.duration;
      const shoundNow = dur * durPercent;
      audioInstance.currentTime = shoundNow;
    },

    onPlaying(a) {
      const audioInstance = this.$refs.audio;
      if (!audioInstance) return;
      const dur = audioInstance.duration;
      const now = audioInstance.currentTime;
      if (!dur || !now) return;

      // this.audioTotalTime = Math.floor(dur).toString();
      const _audioTotalTime = Math.floor(dur);
      const min = Math.floor(_audioTotalTime / 60);
      const sec = _audioTotalTime % 60;

      this.playingPercent = (100 * now) / dur;
    },

    play() {
      const audioInstance = this.$refs.audio;
      audioInstance.play();
      this.playing = true;
    },

    stop() {
      const audioInstance = this.$refs.audio;
      audioInstance.pause();
      this.playing = false;
    },
  },
};
</script>

<style scoped lang="less">
@control-bar-width: 15vh;

.end-container {
  width: 100vw;
  height: 100vh;
  background-image: url("https://jcdn.xhby.net/project/xiaokang/assets/welcome/bg0.jpg");
  background-size: cover;
  background-position: 50% 50%;
  position: relative;
  display: flex;
  flex-direction: column;

  .end-main {
    flex: 1;
    margin-bottom: 10px;

    display: flex;

    .left {
      width: 40%;
      display: flex;
      align-items: center;
      flex-shrink: 0;

      .xi-img-container {
        margin-left: auto;
        width: 30vw;
        height: 27vw;
        position: relative;

        .xi-img {
          width: 100%;
          position: relative;
          top: 14px;
          left: -6px;
        }

        .play-bar {
          width: calc(100% + 10px);
          height: 20px;
          border-radius: 40px;
          background: #cc393f;
          margin-left: auto;
          position: absolute;
          bottom: 0;
          left: 0;
          padding-right: 20px;
          padding-left: 40px;

          .play-icon {
            height: 250%;
            position: absolute;
            left: 0;
            bottom: 0;
            transform: translateX(-50%) translateY(32%);
            z-index: 999;
            cursor: pointer;
          }
        }
      }
    }

    .right {
      flex: 1;

      .xi-text {
        width: 85%;
        position: relative;
        top: 25vh;
        left: -3vh;
      }
    }
  }

  .control-bar {
    margin-top: auto;
    width: 100%;
    height: @control-bar-width;
    background-color: #c23439;
    // background-image: url("https://jcdn.xhby.net/project/xiaokang/assets/end/icon.jpg");
    background-image: url("../new-new-assets/end/bottom-logo.png");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: 50%;
    display: flex;
    justify-content: center;
    // flex-direction: row-reverse;

    .look-more {
      // margin-left: auto;
      color: white;
      padding: 0 40px;
      background: #a8252a;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      cursor: pointer;
      letter-spacing: 1px;
    }

    .banquan {
      padding: 0 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      cursor: pointer;
      letter-spacing: 1px;
      color: white;
      border-left: 1px solid #cf6267;
      border-right: 1px solid #cf6267;
    }

    .fanhui {
      margin-right: 40px;
      padding: 0 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      cursor: pointer;
      letter-spacing: 1px;
      color: white;
      border-right: 1px solid #cf6267;
    }
  }

  .dialog-container {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;

    .dialog-inner {
      width: 1000px;
      height: 60vh;
      border: 10px solid #ffeccb;
      background: white;
      position: relative;

      .close-img {
        position: absolute;
        width: 60px;
        top: -30px;
        right: -30px;
        cursor: pointer;
      }

      .dialog-inner-2 {
        width: 100%;
        height: 100%;
        border: 1px dashed #c56f6f;
        padding: 20px 40px;
        overflow: auto;

        .banquan {
          width: 80%;
          margin: 0 auto;
          display: block;
        }

        .divider {
          height: 20px;
        }

        .line {
          // padding-left: 16%;
          line-height: 30px;
          font-size: 22px;
          color: #a7262b;
          text-align: center;
        }
      }
    }
  }
}

.real-bar-container {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;

  .bg-bar {
    height: 2px;
    width: 100%;
    background: #fa6368;
    cursor: pointer;

    .front-bar {
      height: 100%;
      background: white;
      position: relative;

      .ball {
        width: 8px;
        height: 8px;
        background: white;
        border-radius: 50%;
        position: absolute;
        right: -4px;
        top: -4px;
        transform: translateY(1px);
      }
    }
  }
}
</style>